module.exports = __webpack_public_path__ + "img/Polygon.1a71a713.svg";